module.exports = __webpack_public_path__ + "static/media/apartment13.fafd73e8.png";